import { Component, Input, OnInit } from '@angular/core';
import { Accessory, Vehicle, ConfigAccessory, convertToAccessory } from '../../models';
import { AppService, DealService, VehicleService } from '../../services';

@Component({
  selector: 'app-accessory-menu',
  templateUrl: './accessory-menu.component.html',
  styleUrls: ['./accessory-menu.component.scss']
})
export class AccessoryMenuComponent implements OnInit {
  @Input() vehicle: Vehicle;

  featuredAccessories = {
    new: [],
    certified: [],
    used: []
  }
  selectedAccessories = []

  constructor(
    private appService: AppService,
    private vehicleService: VehicleService,
    private dealService: DealService,
  ) { }

  ngOnInit(): void {
    this.subToStoreData();
  }

  subToStoreData() {
    this.appService.selectLinks().subscribe(links => {
      const newAcc = links.featuredAccessoriesNew || [];
      const certifiedAcc = links.featuredAccessoriesCertified || [];
      const usedAcc = links.featuredAccessoriesUsed || [];

      const filterAndAddFeatured = (accList: ConfigAccessory[]) => {
        return accList.filter(item => item.name !== "").map(item => {
          return {
            ...item,
            featured: true
          }
        })
      };

      this.featuredAccessories.new = filterAndAddFeatured(newAcc);
      this.featuredAccessories.certified = filterAndAddFeatured(certifiedAcc);
      this.featuredAccessories.used = filterAndAddFeatured(usedAcc);
    });

    this.dealService.selectAccessories().subscribe((accessories: Partial<Accessory>[]) => {
      this.selectedAccessories = accessories.filter(a => !a.hidden);
    });
  }

  get accessories(): any[] {
    return this.featuredAccessories[this.vehicleCondition] || [];
  }

  get vehicleCondition(): string {
    return this.vehicleService.vehicleCondition(this.vehicle);
  }

  accessoryInCart(accessory: ConfigAccessory): boolean {
    let accessoryNames = accessory.options?.map((option, index) => convertToAccessory(accessory, index).name) || [];
    return this.selectedAccessories.some(item => accessoryNames.includes(item.name));
  }

  selectedDealAccessory(currentAccessory: ConfigAccessory, selectedAccessories: Partial<Accessory>[]) {
    let accessoryNames = currentAccessory.options?.map((option, index) => convertToAccessory(currentAccessory, index).name) || [];
    return selectedAccessories.find(acc => accessoryNames.includes(acc.name));
  }

  isPaintAccessoryEnabled(currentAccessory: ConfigAccessory, selectedAccessories: Partial<Accessory>[]) {
    if (currentAccessory.name !== "Paint Protection Film") {
      return true;
    }
    let accessoryNames = currentAccessory.options?.map((option, index) => convertToAccessory(currentAccessory, index).name) || [];
    return selectedAccessories.some(acc => accessoryNames.includes(acc.name) && !acc.disabled);
  }
}
